import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const getUrlFromCatalogCode = (code, node) => {
  switch (code) {
    case 'products':
      return `/nodes/${node.id}/products`;
    case 'pests':
      return `/nodes/${node.id}/pests`;
    case 'tips':
      return `/nodes/${node.id}/tips`;
    case 'memos':
      return `/nodes/${node.id}/memos`;
    default:
      return null;
  }
};

const getLabelFromCatalogCode = code => {
  switch (code) {
    case 'products':
      return 'Ajouter un produit';
    case 'pests':
      return 'Ajouter un nuisible';
    case 'tips':
      return 'Ajouter une astuce technique';
    case 'memos':
      return 'Ajouter un mémo technique';
    default:
      return null;
  }
};

const AddEntityButton = ({ catalog, node }) => (
  <Link
    to={getUrlFromCatalogCode(catalog, node)}
    className="ui right floated labeled primary icon button"
  >
    <i className="plus icon" />
    {getLabelFromCatalogCode(catalog)}
  </Link>
);

AddEntityButton.propTypes = {
  catalog: PropTypes.string.isRequired,
  node: PropTypes.object.isRequired,
};

export default AddEntityButton;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/AddEntityButton.js